import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
  AddNewClient,
  Clients,
  CreateNewInvoice,
  Dashboard,
  Documents,
  EditClient,
  EditInvoice,
  Invoices,
  Login,
  Profile,
  Register,
} from 'screens';
import { PrivateRouting } from 'routing';
import { PublicRouting } from 'routing/PublicRouting';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import i18n from 'i18n';
import { ForgotPassword } from 'screens/ForgotPassword';
import { ResetPassword } from 'screens/ResetPassword/ResetPassword';
import { SalaryCalculator } from 'screens/SalaryCalculator/SalaryCalculator';

function App() {
  const { profile } = useSelector((state: RootState) => state.profile);

  useEffect(() => {
    if (profile?.language && i18n.language !== profile.language) {
      i18n.changeLanguage(profile.language);
    }
  }, [profile?.language]);

  return (
    <Router>
      <Routes>
        {/* Public embed (must stay reachable while logged in — used as iframe on payflow.ch/lohnrechner) */}
        <Route path="/calculator" element={<SalaryCalculator />} />

        {/* Public Routes */}
        <Route element={<PublicRouting />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
		  <Route path="/forgot-password" element={<ForgotPassword />} />
		  <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        {/* Private Routes using the layout */}
        <Route element={<PrivateRouting />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/add-new" element={<AddNewClient />} />
          <Route path="/clients/edit/:id" element={<EditClient />} />
          <Route path="/invoices/edit/:id" element={<EditInvoice />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/edit-profile" element={<Profile />} />
          <Route path="/invoices/create-new" element={<CreateNewInvoice />} />
          <Route path="/salary-calculator" element={<SalaryCalculator />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
